<div class="step-header d-flex align-items-center mb-4">
    <button class="step-header__button btn" (click)="onBack()">
        <i class="bi bi-chevron-left step-header__button--icon"></i> Atrás
    </button>
    <div class="step-header__divider"></div>
    <span class="step-header__steps">Paso {{currentStep}} de {{totalSteps}}</span>
</div>
